import { render } from "./CovidBotCounter.vue?vue&type=template&id=1b71aaa9&scoped=true"
import script from "./CovidBotCounter.vue?vue&type=script&lang=js"
export * from "./CovidBotCounter.vue?vue&type=script&lang=js"

import "./CovidBotCounter.vue?vue&type=style&index=0&id=1b71aaa9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b71aaa9"

export default script